import { encode, decode } from 'js-base64';
import { parseDomain, fromUrl } from "parse-domain";

export class Logger
{
    static _storageName = "ai_loggerCache";
    static getFromCache(id)
    {
      if(localStorage.getItem(this._storageName) == null)
      {
          return null;
      }
      let storage = JSON.parse(localStorage.getItem(this._storageName));
      let value = null;

      if(id in storage)
      {
        return storage[id]
      }
      
      return null;
      
    }
    static setToCache(id, value)
    {
      let storage = {};
      if(localStorage.getItem(this._storageName) != null)
      {
          storage = JSON.parse(localStorage.getItem(this._storageName));
      }
      storage[id] = value;
      localStorage.setItem(this._storageName, JSON.stringify(storage))
    }

    static getServiceUrl()
    {
      let domain = this.getDomain();
      let host = null;
      if(domain == 'localhost')
      {
        host = "http://localhost:5000/";
      }
      else
      {
        host = "https://backend.aipredict.us/";
      }
      return host;
    }

    static send(id, message)
    {
        let cachedMessage = this.getFromCache(id);
        if(cachedMessage != null)
        {
          return
        }
        else
        {
          this.setToCache(id, message);
          this.sendRequest(message);
        }
    }
    
    static sendRequest(message)
    {
      if(message == undefined)
      {
        return;
      }

      let json = JSON.stringify(message);
      let compressedJson = encode(json);

      if(compressedJson.indexOf('/') !== -1)
      {
        compressedJson = compressedJson.replace("/", "_");
      }
      let script = document.createElement('script');

      let host = this.getServiceUrl();
      let url = host + "logging/load/" + compressedJson + '/log.js';

      script.setAttribute('src', url);
      script.setAttribute('id','ai_sendLog');

      try
      {
        document.body.appendChild(script);
      }
      catch(error)
      {
        console.log(error);
      }
    }

    static getDomain()
    {
        try
        {
            let href = window.location.href;
            let aiDomain = null;
            let { subDomains, domain, topLevelDomains } = parseDomain(fromUrl(href));
            let topLevelDomainsOnlyList = ["app", "myshopify","goog", "herokuapp"];
            let isTopLevelDomainsOnlyApply = false;

            for (let i = 0; i < topLevelDomainsOnlyList.length; i++) 
            {
            let value = topLevelDomainsOnlyList[i];
            if(topLevelDomains.includes(value))
            {
                isTopLevelDomainsOnlyApply = true;
            }
            }
            if(isTopLevelDomainsOnlyApply == true)
            {
            aiDomain = topLevelDomains.join('.');
            }
            else
            {
            aiDomain = domain + "." + topLevelDomains.join('.');
            }
            if(aiDomain.includes("."))
            {
            aiDomain = aiDomain.replace(".","_");
            }
            return aiDomain; 
        }
        catch(ex)
        {
          console.log(ex);//Logger.logError(ex, "logger.getDomain", "", "");
        }
        return "localhost";
    }

    static logError(exception, methodName, value, input_value)
    {
        let message = {};
        message['description'] = exception.message;
        message['stack'] = exception.stack;
        message['type'] = "error";
        message['method'] = methodName;
        message['value'] = value;
        message['input_value'] = input_value;
        this.send(methodName, message);

    }

    static logMessage(info, methodName, value, input_value)
    {
        let message = {}
        message['description'] = info;
        message['stack'] = "";
        message['type'] = "info";
        message['method'] = methodName;
        message['value'] = value;
        message['input_value'] = input_value;
        this.send(methodName, message);
    }
}